import { inject, Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { Store } from '@ngxs/store';
import { ReservedRole } from 'app/core/enums';
import { UserState } from 'app/state/user/state';
import { getSubdomain } from 'app/shared/Utils/common.utils';

@Injectable({ providedIn: 'root' })
export class BareSubdomainRedirectGuard implements CanActivate {
  private readonly router = inject(Router);
  private readonly store = inject(Store);

  canActivate(): UrlTree {
    const subdomain = getSubdomain();
    if (!subdomain) {
      return this.router.parseUrl('/accounts');
    }
    const isCollaborator = this.store
      .selectSnapshot(UserState.getUser)
      ?.roles?.some((role) => role.name === ReservedRole.Collaborator);
    return this.router.parseUrl(isCollaborator ? '/tasks/global' : '/projects');
  }
}
